<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Le Parcours Disciples d’Emmaüs Sup " />
            <ParcourSup/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import ParcourSup from './ParcourSup.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        ParcourSup,
        FooterComp,
    }
}
</script>